import Reveal from '@/components/base/Reveal';
import { characterRoles } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function CharactersSection() {
  return (
    <section id="characters" className="scroll-mt-16 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Characters"
            title="常见人物类型与角色分工"
            desc="家庭情感题材的作品往往围绕一组稳定的角色关系展开。下面按角色功能梳理出常见的几种人物类型，方便你在阅读时快速辨认每个人的定位。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {characterRoles.map((role, index) => (
            <Reveal key={role.role} delay={index * 60}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 flex flex-col gap-4">
                <div className="flex items-start justify-between gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl">
                    <i className={role.icon} />
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                    {role.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">{role.role}</h3>
                <p className="text-sm leading-relaxed text-foreground-600 flex-1">{role.desc}</p>
                <div className="flex flex-wrap gap-2 pt-1">
                  {role.traits.map((trait) => (
                    <span
                      key={trait}
                      className="px-2.5 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600"
                    >
                      {trait}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}